import { useLocation } from 'react-router';

export type ErpType = 'netsuite' | 'intacct' | 'quickbooks' | 'xero';

export const useErpType = (): ErpType | null => {
    const location = useLocation();
    const path = location.pathname;

    if (path.startsWith('/netsuite')) return 'netsuite';
    if (path.startsWith('/intacct')) return 'intacct';
    if (path.startsWith('/quickbooks')) return 'quickbooks';
    if (path.startsWith('/xero')) return 'xero';
    return null;
};